import { CustomerInfo } from '@revenuecat/purchases-capacitor';

export enum AppActionType {
  SET_REVENUECAT_CUSTOMER = `SET_REVENUECAT_CUSTOMER`,
  SET_UPGRADE_DIALOG_VISIBLE = `SET_UPGRADE_DIALOG_VISIBLE`,
}

export interface SetRevenueCatCustomerAction {
  type: AppActionType.SET_REVENUECAT_CUSTOMER;
  payload: CustomerInfo;
}

export interface SetUpgradeDialogVisibleAction {
  type: AppActionType.SET_UPGRADE_DIALOG_VISIBLE;
  payload: boolean;
}

export type AppActions = SetRevenueCatCustomerAction | SetUpgradeDialogVisibleAction;
